import { render } from "./PanelAvisosHome.vue?vue&type=template&id=7d12c0e8"
import script from "./PanelAvisosHome.vue?vue&type=script&lang=ts"
export * from "./PanelAvisosHome.vue?vue&type=script&lang=ts"
script.render = render

export default script